<script setup>
import { Head, useForm } from '@inertiajs/inertia-vue3';
import BlankLayout from '../../Layouts/BlankLayout';
import Icone from '../../Componentes/Global/Icone';
import useRotas from '../../Composables/useRotas';
import { useQuasar } from 'quasar';
import FormRow from '../../Componentes/Forms/FormRow';
import FormInput from '../../Componentes/Forms/FormInput';
import FormGroupLabel from '../../Componentes/Forms/FormGroupLabel';
import { cpf } from 'cpf-cnpj-validator';
import isEmail from 'validator/lib/isEmail';
import {computed, onMounted, ref} from 'vue';

const $q = useQuasar();
const route = useRotas();

const listaEstadoUF = ref([]);
const listaInteresses = ref([]);

const atualizarListaEstadoUF = async () => {
    const response = await fetch(route('utilidades.listaEstadoUF'), {
        method: 'GET',
        credentials: 'include'
    });

    const lista = await response.json();

    lista.forEach(estado => {
        listaEstadoUF.value.push(estado);
    });

    console.log(listaEstadoUF.value);

}

const atualizarListaInteresses = async () => {
    const response = await fetch(route('utilidades.listaInteresses'), {
        method: 'GET',
        credentials: 'include'
    });

    const lista = await response.json();

    lista.forEach(interesse => {
        listaInteresses.value.push(interesse);
    });

}

onMounted(async() =>{
    await atualizarListaEstadoUF();
    await atualizarListaInteresses();
});

const form = useForm({
    nomeUsuario: null, // 'Teste Novo',
    senha: null, // '123456789Aa@',
    nomeCompleto: null, // 'Teste Novo',
    cpf: null, // '04884383060',
    rg: null, // '560398301',
    orgaoEmissorRg: null, // 'Teste Novo',
    nacionalidade: null, // 0,
    sexo: null, // 0,
    dataDeNascimento: null, // '07/12/2000',
    profissao: null, // 'Teste Novo',
    nomeDaMae: null, // 'Teste Novo',
    nomeDoPai: null, // 'Teste Novo',
    email: null, // 'teste@teste.com',
    celular: null, // '11954125910',
    telefone: null, // '11954125910',
    telefoneRecado: null, // '11954125910',
    estadoCivil: null, // 1,
    regimeCasamento: null, // 0,
    dataCasamento: null, // '18/04/2022',
    dataDeNascimentoConjuge: null, // '18/04/2022',
    nomeConjuge: null, // 'Teste Novo',
    rgConjuge: null, // '56039830X',
    orgaoEmissorRgConjuge: null, //
    cpfConjuge: null, // '46283413897',
    profissaoConjuge: null, // 'Teste Novo',
    nacionalidadeConjuge: null, // 0,
    cep: null, // '09667000',
    estado: null, // 'Teste Novo',
    cidade: null, // 'Teste Novo',
    bairro: null, // 'Teste Novo',
    endereco: null, // 'Teste Novo',
    numero: null, // 'Teste Novo',
    complemento: null, // 'Teste Novo',
    referencia: null, // 'Teste Novo',
    referenciaBancaria: null, // 'Teste Novo',
    informacoesExtras: null, // 'Teste Novo',
    interesses: [],
});

// const form = useForm({
//     nomeUsuario: 'Teste Novo',
//     senha: '123456789Aa@',
//     nomeCompleto: 'Teste Novo',
//     cpf: '04884383060',
//     rg: '560398301',
//     orgaoEmissorRg: 'Teste Novo',
//     nacionalidade: 0,
//     sexo: 0,
//     dataDeNascimento: '20122000',
//     profissao: 'Teste Novo',
//     nomeDaMae: 'Teste Novo',
//     nomeDoPai: 'Teste Novo',
//     email: 'teste@teste.com',
//     celular: '11999998887',
//     telefone: null,
//     telefoneRecado: null,
//     estadoCivil: 0,
//     regimeCasamento: null,
//     dataCasamento: null,
//     dataDeNascimentoConjuge: null,
//     nomeConjuge: null,
//     rgConjuge: null,
//     orgaoEmissorRgConjuge: null,
//     cpfConjuge: null,
//     profissaoConjuge: null,
//     nacionalidadeConjuge: null,
//     cep: '09667000',
//     estado: 'SP',
//     cidade: 'CIDADE',
//     bairro: 'BAIRRO',
//     endereco: 'ENDERECO',
//     numero: '999',
//     complemento: 'Teste Novo',
//     referencia: 'Teste Novo',
//     referenciaBancaria: 'Teste Novo',
//     informacoesExtras: 'Teste Novo',
//     interesses: [] //
// })

const campos = {
    tituloAcesso: {
        tipo: 'titulo',
        texto: 'Dados de Acesso'
    },
    nomeUsuario: {
        tipo: 'campo',
        largura: 6,
        label: 'Apelido',
        dica: 'Este será o nome que aparecerá no site para outros usuários, não pode ser um email',
        autocomplete: 'username',
        icon: 'mdi-account',
        required: true,
        regras: [
            val => val && !/(.com|@)/.test(val) || 'Este campo não pode ser um email.',
            val => val && !isEmail(val) || 'Este campo não pode ser um email',
            val => val && val.length > 5 || 'Deve ter mais de 5 caracteres'
        ]
    },
    senha: {
        tipo: 'campo',
        largura: 6,
        label: 'Senha',
        type: 'password',
        autocomplete: 'password',
        icon: 'mdi-key-variant',
        required: true,
        regras: [
            val => val && val.length >= 6 || 'Senha muito curta, ela deve ter 6 ou mais caracteres',
            val => val && /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$&*])/.test(val) || 'A senha deve ter ao menos uma letra minuscula, uma maiuscula e um caractere especial'
        ]
    },
    tituloPessoais: {
        tipo: 'titulo',
        texto: 'Dados Pessoais'
    },
    nomeCompleto: {
        tipo: 'campo',
        largura: 6,
        label: 'Nome Completo',
        autocomplete: 'name',
        icon: 'mdi-account',
        required: true,
        regras: []
    },
    cpf: {
        tipo: 'campo',
        largura: 6,
        label: 'CPF',
        autocomplete: 'off',
        icon: 'mdi-card-account-details',
        required: true,
        mascara: '###.###.###-##',
        regras: [
            val => val && val.length === 11 || 'Por favor, digite o seu CPF igual está no documento.',
            val => val && cpf.isValid(val) || 'Este CPF parece estar incorreto, por favor, verifique para erros de digitação.',
        ]
    },
    rg: {
        tipo: 'campo',
        largura: 6,
        label: 'RG',
        autocomplete: 'off',
        icon: 'mdi-card-account-details',
        required: true,
        maxlength: 25,
        regras: []
    },
    orgaoEmissorRg: {
        tipo: 'campo',
        largura: 6,
        label: 'Orgão Expeditor RG',
        autocomplete: 'off',
        icon: 'mdi-card-account-details',
        required: true,
        regras: []
    },
    nacionalidade: {
        tipo: 'campo',
        opcoes: [
            {
                label: 'Brasileiro',
                value: 0,
            },
            {
                label: 'Estrangeiro',
                value: 1,
            },
        ],
        largura: 6,
        label: 'Nacionalidade',
        autocomplete: 'off',
        icon: 'mdi-flag-variant',
        required: true,
        regras: []
    },
    sexo: {
        tipo: 'campo',
        largura: 6,
        label: 'Sexo',
        autocomplete: 'off',
        icon: 'mdi-gender-male-female',
        required: true,
        regras: [],
        opcoes: [
            {
                label: 'Masculino',
                value: 0,
            },
            {
                label: 'Feminino',
                value: 1,
            },
            {
                label: 'Não Informado',
                value: 2,
            },
        ],

    },
    dataDeNascimento: {
        tipo: 'campo',
        largura: 6,
        label: 'Data de nascimento',
        autocomplete: 'bday',
        data: true,
        optionsFn: (date) =>{
            return new Date(date) < new Date((new Date()).getTime()-(24*60*60*1000*365*18));
        },
        dataDefaultYM: `${new Date((new Date()).getTime()-(24*60*60*1000*365*18)).getFullYear()}/${new Date((new Date()).getTime()-(24*60*60*1000*365*18)).getMonth()+1}`,
        icon: 'mdi-cake',
        required: true,
        mascara: '##/##/####',
        regras: []
    },
    profissao: {
        tipo: 'campo',
        largura: 6,
        label: 'Profissão',
        autocomplete: 'off',
        icon: 'mdi-briefcase',
        required: true,
        regras: []
    },
    nomeDaMae: {
        tipo: 'campo',
        largura: 6,
        label: 'Nome da mãe',
        autocomplete: 'off',
        icon: 'mdi-human-female',
        required: true,
        regras: []
    },
    nomeDoPai: {
        tipo: 'campo',
        largura: 6,
        label: 'Nome do pai',
        autocomplete: 'off',
        icon: 'mdi-human-male',
        required: false,
        regras: []
    },
    email: {
        tipo: 'campo',
        largura: 6,
        label: 'Email',
        autocomplete: 'email',
        icon: 'mdi-email',
        required: true,
        regras: [
            val => val && isEmail(val) || 'Por favor, preencha um email valido',
        ]
    },
    celular: {
        tipo: 'campo',
        largura: 6,
        label: 'DDD + Celular',
        autocomplete: 'off',
        icon: 'mdi-cellphone',
        required: true,
        regras: [
            val => ![
                '11 11111-1111',
                '22 22222-2222',
                '33 33333-3333',
                '44 44444-4444',
                '55 55555-5555',
                '66 66666-6666',
                '77 77777-7777',
                '88 88888-8888',
                '99 99999-9999',
                '12 34567-8910',
                '11 12345-6789',
                '12 33214-5665',
                '12 34567-8912'
            ].includes(val) || 'Telefone Inválido',
        ],
        mascara: '## #####-####'
    },
    telefone: {
        tipo: 'campo',
        largura: 6,
        label: 'DDD + Telefone Fixo',
        autocomplete: 'off',
        icon: 'mdi-phone',
        required: false,
        regras: [
            val => ![
                '11 1111-1111',
                '22 2222-2222',
                '33 3333-3333',
                '44 4444-4444',
                '55 5555-5555',
                '66 6666-6666',
                '77 7777-7777',
                '88 8888-8888',
                '99 9999-9999',
                '12 3456-8910',
                '11 1234-6789',
                '12 3321-5665',
                '12 3456-8912'
            ].includes(val) || 'Telefone Inválido',
        ],
        mascara: '## ####-####'
    },
    telefoneRecado: {
        tipo: 'campo',
        largura: 6,
        label: 'DDD + Telefone para recado',
        autocomplete: 'off',
        icon: 'mdi-phone-in-talk',
        required: false,
        regras: [
            val => ![
                '11 11111-1111',
                '22 22222-2222',
                '33 33333-3333',
                '44 44444-4444',
                '55 55555-5555',
                '66 66666-6666',
                '77 77777-7777',
                '88 88888-8888',
                '99 99999-9999',
                '12 34567-8910',
                '11 12345-6789',
                '12 33214-5665',
                '12 34567-8912'
            ].includes(val) || 'Telefone Inválido',
        ],
        mascara: '## #####-####'
    },
    estadoCivil: {
        tipo: 'campo',
        largura: 6,
        label: 'Estado Civil',
        autocomplete: 'off',
        icon: 'mdi-ring',
        required: true,
        opcoes: [
            {
                label: 'Solteiro(a)',
                value: 0,
            },
            {
                label: 'Casado(a)',
                value: 1,
            },
            {
                label: 'Divorciado(a)',
                value: 2,
            },
            {
                label: 'Viuvo(a)',
                value: 3,
            },
            {
                label: 'União Estavel',
                value: 4,
            },
        ]
    },
    tituloCasamento: {
        tipo: 'titulo',
        texto: 'Dados Conjuge',
        condicional: computed(() => form.estadoCivil === 1)
    },
    regimeCasamento: {
        tipo: 'campo',
        largura: 6,
        label: 'Regime de casamento',
        autocomplete: 'off',
        icon: 'mdi-script',
        required: true,
        opcoes : [
            {
                label: 'Comunhão Parcial de Bens',
                value: 0,
            },
            {
                label: 'Comunhão Universal de Bens',
                value: 1,
            },
            {
                label: 'Separação Convencional de Bens',
                value: 2,
            },
            {
                label: 'Separação Obrigatória de Bens',
                value: 3,
            },
            {
                label: 'Participação final nos Aquestos',
                value: 4,
            },
        ],
        condicional: computed(() => form.estadoCivil === 1)
    },
    dataCasamento: {
        tipo: 'campo',
        largura: 6,
        label: 'Data de casamento',
        autocomplete: 'off',
        icon: 'mdi-cake',
        optionsFn: (date) =>{
            return new Date(date) < new Date();
        },
        required: true,
        data: true,
        mascara: '##/##/####',
        regras: [],
        condicional: computed(() => form.estadoCivil === 1)
    },
    dataDeNascimentoConjuge: {
        tipo: 'campo',
        largura: 6,
        label: 'Data de nascimento do Conjuge',
        autocomplete: 'off',
        icon: 'mdi-cake',
        optionsFn: (date) =>{
            return new Date(date) < new Date();
        },
        required: true,
        data: true,
        mascara: '##/##/####',
        regras: [],
        condicional: computed(() => form.estadoCivil === 1)
    },
    nomeConjuge: {
        tipo: 'campo',
        largura: 6,
        label: 'Nome do cônjugue',
        autocomplete: 'off',
        icon: 'mdi-account-supervisor',
        required: true,
        regras: [
        ],
        condicional: computed(() => form.estadoCivil === 1)
    },
    rgConjuge: {
        tipo: 'campo',
        largura: 6,
        label: 'RG do cônjugue',
        autocomplete: 'off',
        icon: 'mdi-card-account-details',
        required: true,
        maxlength: 25,
        regras: [],
        condicional: computed(() => form.estadoCivil === 1)
    },
    orgaoEmissorRgConjuge: {
        tipo: 'campo',
        largura: 6,
        label: 'Orgão Expeditor RG do conjuge',
        autocomplete: 'off',
        icon: 'mdi-card-account-details',
        required: true,
        regras: [],
        condicional: computed(() => form.estadoCivil === 1)
    },
    cpfConjuge: {
        tipo: 'campo',
        largura: 6,
        label: 'CPF do cônjugue',
        autocomplete: 'off',
        icon: 'mdi-card-account-details',
        required: true,
        mascara: '###.###.###-##',
        regras: [
            val => val && val.length === 11 || 'Por favor, digite o seu CPF igual está no documento.',
            val => val && cpf.isValid(val) || 'Este CPF parece estar incorreto, por favor, verifique para erros de digitação.',
        ],
        condicional: computed(() => form.estadoCivil === 1)
    },
    profissaoConjuge: {
        tipo: 'campo',
        largura: 6,
        label: 'Profissao do cônjugue',
        autocomplete: 'off',
        icon: 'mdi-briefcase',
        required: true,
        regras: [],
        condicional: computed(() => form.estadoCivil === 1)
    },
    nacionalidadeConjuge: {
        tipo: 'campo',
        largura: 6,
        label: 'Nacionalidade do cônjuge',
        autocomplete: 'off',
        icon: 'mdi-flag-variant',
        required: true,
        opcoes: [
            {
                label: 'Brasileiro',
                value: 0,
            },
            {
                label: 'Estrangeiro',
                value: 1,
            },
        ],
        condicional: computed(() => form.estadoCivil === 1)
    },
    tituloEndereco: {
        tipo: 'titulo',
        texto: 'Endereço'
    },
    cep: {
        tipo: 'campo',
        largura: 6,
        label: 'CEP',
        autocomplete: 'postcode',
        icon: 'mdi-map-search',
        required: true,
        mascara: '#####-###',
        regras: [
            val => val && val.length >= 5 || 'CEP Inválido',
        ],
        onChange: async () => {
            if (form.cep.length > 6){
                let resultado;
                try {
                    console.log(route('utilidades.consultaCep', {cep: form.cep}))
                    $q.loading.show({
                        message: 'Procurando seu CEP...'
                    });
                    resultado = await (await fetch(route('utilidades.consultaCep', {cep: form.cep}), {
                        method: 'GET',
                        credentials: 'include'
                    })).json();

                    $q.loading.hide();
                    form.endereco = (resultado.nome) ? `${resultado.tipo} ${resultado.nome}` : '';
                    form.bairro = resultado.bairro.nome;
                    form.cidade = resultado.bairro.cidade.nome;
                    //form.estado = resultado.bairro.cidade.estado.nome;
                    form.estado = resultado.bairro.cidade.estado.codigo_uf;
                } catch (e) {
                    $q.notify({
                        icon: 'mdi-map-marker-remove',
                        message: 'O CEP fornecido não foi encontrado',
                        color: 'negative'
                    })
                }
            }
        }
    },
    estado: {
        tipo: 'campo',
        largura: 6,
        label: 'Estado',
        autocomplete: 'off',
        icon: 'mdi-map',
        required: true,
        opcoes: listaEstadoUF.value,
        readonly: false,
        regras: []
    },
    cidade: {
        tipo: 'campo',
        largura: 6,
        label: 'Cidade',
        autocomplete: 'off',
        icon: 'mdi-city-variant',
        required: true,
        readonly: false,
        regras: [
                    val => val && val.length <= 100 || 'Cidade deve ser abreviada',
                ]
    },
    bairro: {
        tipo: 'campo',
        largura: 6,
        label: 'Bairro',
        autocomplete: 'off',
        icon: 'mdi-home-map-marker',
        required: true,
        readonly: false,
        regras: [
            val => val && val.length <= 100 || 'Bairro deve ser abreviado',
        ]
    },
    endereco: {
        tipo: 'campo',
        largura: 4,
        label: 'Rua',
        autocomplete: 'off',
        icon: 'mdi-map-marker-multiple',
        required: true,
        regras: [
            val => val && val.length <= 150 || 'Endereço deve ser abreviado',
        ]
    },
    numero: {
        tipo: 'campo',
        largura: 4,
        label: 'Número',
        autocomplete: 'off',
        icon: 'mdi-pin',
        required: true,
        regras: []
    },
    complemento: {
        tipo: 'campo',
        largura: 4,
        label: 'Complemento',
        autocomplete: 'off',
        icon: 'mdi-pin',
        required: false,
        regras: []
    },
    tituloInteresses: {
        tipo: 'titulo',
        texto: 'Interesses'
    },
    interesses: {
        tipo: 'checkbox',
        largura: 6,
        label: 'Interesses',
        autocomplete: 'off',
        icon: 'mdi-map',
        required: true,
        opcoes: listaInteresses.value,
        readonly: false,
        regras: []
    },
    tituloExtra: {
        tipo: 'titulo',
        texto: 'Informações Extra'
    },
    // referencia: {
    //     tipo: 'campo',
    //     largura: 6,
    //     label: 'Senha',
    //     autocomplete: 'password',
    //     icon: 'mdi-key-variant',
    //     required: true,
    //     regras: [
    //         val => val && val.length >= 6 || 'Senha muito curta, ela deve ter 6 ou mais caracteres',
    //         val => val && /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$&*])/.test(val) || 'A senha deve ter ao menos uma letra minuscula, uma maiuscula e um caractere especial'
    //     ]
    // },
    // referenciaBancaria: {
    //     tipo: 'campo',
    //     largura: 6,
    //     label: 'Senha',
    //     autocomplete: 'password',
    //     icon: 'mdi-key-variant',
    //     required: true,
    //     regras: [
    //         val => val && val.length >= 6 || 'Senha muito curta, ela deve ter 6 ou mais caracteres',
    //         val => val && /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$&*])/.test(val) || 'A senha deve ter ao menos uma letra minuscula, uma maiuscula e um caractere especial'
    //     ]
    // },
    informacoesExtras: {
        tipo: 'campo',
        largura: 12,
        label: 'Informações Extras',
        autocomplete: 'password',
        icon: 'mdi-file-document-multiple-outline',
        required: false,
        regras: []
    },
};
</script>

<template>
    <Head title="Cadastro Pessoa Fisica" />
    <BlankLayout>
        <q-page class="flex row justify-center items-start q-py-md">
            <div class="flex column items-center col-11">
                <icone height="7em" width="14em" />
                <h4
                    class="text-center text-primary font-weight-light q-ma-md q-mb-lg"
                    :class="$q.screen.gt.sm ? 'text-h4' : 'text-h5'">
                    Cadastro de pessoa física
                </h4>
                <q-form class="full-width" @submit="form.post(route('cadastro.fisica.processar'))">
                    <form-row>
                        <template :key="indice" v-for="(config, campo, indice) in campos">
                            <template v-if="config.condicional === undefined || config.condicional.value">
                                <template v-if="config.tipo === 'titulo'">
                                    <form-group-label :text="config.texto" />
                                </template>
                                <template v-if="config.tipo === 'checkbox'">
                                    <q-field
                                        v-model="form[campo]"
                                        borderless
                                        dense
                                        :rules="[ val => +val?.length > 0 || '']"
                                    >
<!--                                        <template v-slot:error>-->
<!--                                            Please use a maximum value of 30.-->
<!--                                        </template>-->
                                        <q-option-group
                                            v-model="form[campo]"
                                            :options="config.opcoes"
                                            color="primary"
                                            type="checkbox"
                                            inline
                                            class="q-mx-none q-mb-md full-width"
                                            size="lg"
                                        />
                                    </q-field>
                                </template>
                                <template v-if="config.tipo === 'campo'">
                                    <form-input
                                        v-model="form[campo]"
                                        :dica="config.dica"
                                        :autocomplete="config.autocomplete"
                                        :label="config.label"
                                        :rules="config.regras"
                                        :type="config.type"
                                        :icon="config.icon"
                                        :required="config.required"
                                        :largura="config.largura"
                                        :mascara="config.mascara"
                                        :opcoes="config.opcoes"
                                        :data="config.data"
                                        :readonly="config.readonly"
                                        :optionsFn="config.optionsFn"
                                        :dataDefaultYM="config.dataDefaultYM"
                                        :maxlength="config.maxlength"
                                        @change="config.onChange"
                                    />
                                </template>
                            </template>
                        </template>
                    </form-row>
                    <q-btn
                        class="full-width"
                        color="primary"
                        label="Prosseguir"
                        icon-right="mdi-arrow-right"
                        type="submit"
                        :loading="form.processing"
                    />
                </q-form>
            </div>
        </q-page>
    </BlankLayout>
</template>
